interface InfoBannerProps {
  title: string;
  children: React.ReactNode;
}

const InfoBanner = ({ title, children }: InfoBannerProps) => {
  return (
    <div
      data-testid="InfoBannerContainer"
      id="InfoBannerContainer"
      className="rounded-lg border border-blue-200 bg-gray-50 px-4 py-3 dark:border-blue-800 dark:bg-gray-800"
    >
      <p className="text-sm font-medium text-blue-800 dark:text-blue-300">
        {title}
      </p>
      <p className="mt-1 text-xs text-blue-700 dark:text-blue-400">
        {children}
      </p>
    </div>
  );
};

export default InfoBanner;
